import React from 'react'
import './style.css'
const index = () => {
  
    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }

  return (
    <div className="component-desc">
            <h2 className="heading">Badge</h2>
            <div className="description"> Badge are generally used to display numbers, online / offline status,tags,etc depending on where they are used.They are usually positioned at top-right or botton-right of the parent component.</div>
            <div className="divider"></div>
            <h4 className="heading">Badge</h4>
            <div style={{display:'flex',justifyContent:'spaceAround'}}>
                <span className="badge badge--primary">New</span>
                <span className="badge badge--secondary">Trending</span>
                <span className="badge badge--success">Best Seller</span>
                <span className="badge badge--warning">Viral</span>
                <span className="badge badge--danger">Hot</span>
            </div>
            <div className="carbon-container">
                <iframe className="iframe"
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cspan%2520class%253D%2522badge%2520badge--primary%2522%253ENew%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--secondary%2522%253ETrending%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--success%2522%253EBest%2520Seller%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--warning%2522%253EViral%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--danger%2522%253EHot%253C%252Fspan%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
            <div className="divider"></div>
            <h4 className="heading">Badge Rounded</h4>
            <div style={{display:'flex',justifyContent:'spaceAround'}}>
                <span className="badge badge--rounded badge--primary">10% off</span>
                <span className="badge badge--rounded badge--secondary">20% off</span>
                <span className="badge badge--rounded badge--success">30% off</span>
                <span className="badge badge--rounded badge--warning">40% off</span>
                <span className="badge badge--rounded badge--danger">50% off</span>
            </div>
            <div className="carbon-container">
                <iframe className="iframe"
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cspan%2520class%253D%2522badge%2520badge--rounded%2520badge--primary%2522%253E10%2525%2520off%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--rounded%2520badge--secondary%2522%253E20%2525%2520off%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--rounded%2520badge--success%2522%253E30%2525%2520off%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--rounded%2520badge--warning%2522%253E40%2525%2520off%253C%252Fspan%253E%250A%253Cspan%2520class%253D%2522badge%2520badge--rounded%2520badge--danger%2522%253E50%2525%2520off%253C%252Fspan%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
            <div className="divider"></div>
        </div>
  )
}

export default index